import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import moment from "moment";
const InvoiceList = () => {
  const navigate = useNavigate();
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Invoice ID",
      accessorKey: "invoice_id",
      cell: NACell,
    },
    {
      header: "Vendor Name",
      accessorKey: "user.full_name",
      cell: NACell,
    },
    {
      header: "D. Charge",
      accessorKey: "delivery_charge.charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
          </>
        );
      },
    },
    {
      header: "Tax",
      accessorKey: "tax",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue()}</p>
          </>
        );
      },
    },
    {
      header: "Paid Date",
      accessorKey: "settlement_date",
      cell: NACell,
    },
    {
      header: "Remarks",
      accessorKey: "remarks",
      cell: NACell,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: NACell,
    },
  ];
  const handleRowClick = (row) => {
    navigate(`invoicedetail/${row?.original?.id}`);
  };
  return (
    <DataTable
      url={APIS.INVOICE}
      queryKey={"Invoice"}
      columns={defaultColumns}
      handleRowClick={handleRowClick}
      addNewPagePath={""}
      tableName={"Invoice"}
    />
  );
};

export default InvoiceList;
